

// object to store loaded CSS chunks
var installedCssChunks = {
	826: 0
}
__webpack_require__.f.compat = (chunkId, promises) => {


	// mini-css-extract-plugin CSS loading
	var cssChunks = {"120":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
			var href = "" + {"18":"f9b82434bd7f1311c2cd","34":"e001f122659118ae8383","37":"44c23cf27d980b49697e","88":"56fb83740ce70e653706","119":"db045cb841ce869dc10b","120":"55a5be39869dce1c9723","159":"f40fd370287caef039b3","340":"4ced167afb1ef82c59f3","346":"1dd5bcd95e93e74d081a","362":"3342cfc4eeb9c404c795","373":"7dda058bf5e081f975ef","378":"2e914d646f6aceef285e","406":"c809219801307f3c7a6b","408":"ae130c122353380314c6","413":"f5fdbdd3255605a027d2","422":"94b9f3dccf5ba7d0453c","459":"9870e6c1299b941dc97d","464":"d64a02e99adeda594ff8","495":"010f86fc9a83fa8ab1d9","557":"6e2fcd091212a81da70b","578":"f79e1d52843f3eeb1d91","586":"5564c8d37588cab9d037","603":"f943c4e2c92804e618d4","737":"0fe3b2f932004a19024d","770":"d75cd99d87d4fd95464b","781":"bb074727268b1e1a9436","786":"9ddc30e85c17be7eba42","827":"6a87ef869140f374f2bc","831":"a6411bf8d24c7f7b531a","845":"0dc9e5313e25b5aa7f82","848":"45db6445bc45c0aa1895","850":"50be7a101346aad6ba81","863":"ba3e045573afe6ad98a0","877":"57fba431f008fd774799","894":"a281c15142fb7003b6c4","897":"e1634c6cc6e6dd8b51dd","912":"e3e0ecfb924bc560860b","942":"c6ad99338bac08df05d7","970":"c1354a795be62caf6c5c"}[chunkId] + "/style.css";
			var fullhref = __webpack_require__.p + href;
			var existingLinkTags = document.getElementsByTagName("link");
			for(var i = 0; i < existingLinkTags.length; i++) {
				var tag = existingLinkTags[i];
				var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
				if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
			}
			var existingStyleTags = document.getElementsByTagName("style");
			for(var i = 0; i < existingStyleTags.length; i++) {
				var tag = existingStyleTags[i];
				var dataHref = tag.getAttribute("data-href");
				if(dataHref === href || dataHref === fullhref) return resolve();
			}
			var linkTag = document.createElement("link");
			linkTag.rel = "stylesheet";
			linkTag.type = "text/css";
			linkTag.onload = resolve;
			linkTag.onerror = function(event) {
				var request = event && event.target && event.target.src || fullhref;
				var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
				err.request = request;
				delete installedCssChunks[chunkId]
				linkTag.parentNode.removeChild(linkTag)
				reject(err);
			};
			linkTag.href = fullhref;
			var head = document.getElementsByTagName("head")[0];
			head.appendChild(linkTag);
		}).then(function() {
			installedCssChunks[chunkId] = 0;
		}));
	}
};